import { action, makeObservable, observable } from 'mobx';

class MainLayoutStore {
  contentWidth = 0;

  constructor() {
    makeObservable(this, {
      contentWidth: observable,
      setContentWidth: action,
    });
  }

  setContentWidth(width: number): void {
    this.contentWidth = width;
  }
}

export const mainLayoutStore = new MainLayoutStore();
